import { useField } from 'formik';
import { motion } from 'framer-motion';
import { GiCheckMark } from 'react-icons/gi';
import { loginFormVariants } from '../../../constants/animationVariants';

interface IAcademiaRadioField {
  title?: string;
  id: string;
  name: string;
  value: string;
  variant?: 'primary' | 'secondary';
  label?: string;
  isRequired?: boolean;
  isReadOnly?: boolean;
}

const AcademiaRadioField = ({
  title,
  id,
  name,
  value,
  label,
  variant = 'primary',
  isRequired,
  isReadOnly,
}: IAcademiaRadioField) => {
  // integration of formik hooks here
  const [field, meta] = useField({ name });

  // rendering custom radio field component here
  return (
    <motion.label
      htmlFor={id}
      initial={{ x: 0 }}
      animate={
        meta.touched && meta.error
          ? {
              x: [0, -100, 0, 100, 0],
              transition: {
                duration: 0.1,
                repeat: 2,
              },
            }
          : { x: 0 }
      }
      className={`border  bg-transparent hover:bg-gray-200 rounded-lg p-2 cursor-pointer  duration-300 flex items-center gap-2 ${
        !isReadOnly ? 'hover:opacity-70 active:!scale-95  duration-300' : ''
      } ${
        meta.touched && meta.error
          ? 'border-base-red'
          : 'border-legal-dark-blue'
      }`}
    >
      <div
        title={title}
        className={`flex items-center justify-center size-5 rounded-md border-2 duration-300 ${
          field.value === value
            ? variant === 'primary'
              ? 'bg-legal-dark-blue border-legal-dark-blue'
              : 'bg-base-orange border-base-orange'
            : meta.touched && meta.error
            ? 'bg-transparent border-base-red'
            : 'bg-transparent border-legal-dark-blue'
        } ${isReadOnly ? 'opacity-60 cursor-not-allowed' : ''}`}
      >
        <motion.div
          variants={loginFormVariants}
          initial='hidden'
          animate={field.value === value ? 'visible' : 'hidden'}
        >
          <GiCheckMark
            className={`size-3 ${
              variant === 'primary' ? 'text-legal-brown' : 'text-base-white'
            }`}
          />
        </motion.div>
      </div>

      <input
        type='radio'
        id={id}
        className='hidden'
        {...field}
        value={value}
        readOnly={isReadOnly}
        disabled={isReadOnly}
      />

      {label && (
        <span
          className={`${
            field.value === value
              ? 'text-legal-brown'
              : meta.touched && meta.error
              ? 'text-base-red'
              : 'text-legal-dark-blue'
          } font-medium`}
        >
          {label} {isRequired && <span className='text-base-red'>*</span>}
        </span>
      )}
    </motion.label>
  );
};

export default AcademiaRadioField;
